<template>
  <div>
    <h2 class="text-light">Features</h2>
      <p>
        On poe.watch you can see the market price from all items from the game
        Path of Exile. The tool is using a specific API that is returning every new item people are willing to trade. From all of these this page is calculating a price which should present the approx. price for the item. If you see any items in red, that means they have low confidence. Better said they are quite rare on the market and it's hard to calculate a good price for them. That's also valid for the "Bases" and "Enchants" sections. If you are in a category you can get a more detailed view of an item if you click on the row or the hourglass.
      </p>
      <h4>Detailed view</h4>
      <p>
        More information about a specific item, that means the basic information,
        a history and mods.
      </p>
      <h4>Perfect prices</h4>
      <p>
        If you are on the detailed view from a unique item, they will sometimes
        have a perfectPrice field. There you can see what this item could cost
        with "perfect rolls".
      </p>
      <h4>Corruptions</h4>
      <p>
        On the detailed view from some unique items you will also find a
        corruptions tab. There you can see the item price with the given
        corruption.
      </p>
      <h4>Enchants</h4>
      <p>
        On the detailed view from some unique items you will also find an
        enchants tab. There you can see the item price with the given enchant.
      </p>
  </div>
</template>

<script>
export default {
mounted(){
    console.log("MOUNTED")
}
}
</script>

<style>

</style>